export const DASHBOARD_TITLES: Record<string, string> = {
  main: 'Hola',
  drivers: 'Conductores',
  plan: 'Planes disponibles',
  vehicles: 'Vehículos',
  profile: 'Perfil',
  billing: 'Facturación',
  transactions: 'Transacciones',
  reports: 'Reportes',
  vehicle: 'Reporte de Gastos por Vehículo',
  services: 'Reporte de Tipos de Servicios Realizados',
  geographic: 'Reporte de Uso por Zona Geográfica',
  partner: 'Reporte de Proveedores Aliados Utilizados',
  benefits: 'Beneficios',
  scheduling: 'Agendamiento',
  repuestos: 'Repuestos',
  catalogo: 'Repuestos',
  configurar: 'Configurar pedido',
  seguimiento: 'Seguimiento del pedido',
}